<div class="topnav" role="banner">
  <div class="topnav__bar">
    <div class="container topnav__container">
      <mat-toolbar class="topnav__toolbar h-100 p-0">
        <div class="topnav__inner">
          <div class="topnav__brand">
            <a
              class="topnav__brand-link"
              [routerLink]="homeDashboardPath"
              aria-label="Go to dashboard">
              @if (!llttfPage) {
                <img
                  src="assets/bblogo.png"
                  alt="BounceBack Logo"
                  class="topnav__logo-img" />
              }
              @if (llttfPage) {
                <img
                  src="assets/llttflogo.png"
                  alt="LLTTF Logo"
                  class="topnav__logo-img topnav__logo-img--llttf" />
              }
            </a>
          </div>

          <nav class="topnav__links" aria-label="Main navigation">
            <ul class="topnav__menu topnav__menu--desktop menu" *ngIf="!isParticipant">
              <li class="menu-item" [hidden]="lockNavForOnboarding">
                <a [routerLink]="homeDashboardPath" routerLinkActive="active-link" [routerLinkActiveOptions]="{ exact: true }" class="dashboard-link">Dashboard</a>
              </li>
              <li class="menu-item" [hidden]="!accessControl.userManagement || lockNavForOnboarding">
                <a routerLink="/user-list" [class.active-link]="activeLink === 'user-management'" routerLinkActive="active-link" [routerLinkActiveOptions]="{ exact: true }" class="dashboard-link">Users</a>
              </li>
              <li class="menu-item" [hidden]="!showRoleTrainingNav">
                <a routerLink="/role-training-list" [class.active-link]="activeLink === 'role-training'" routerLinkActive="active-link" [routerLinkActiveOptions]="{ exact: true }" class="dashboard-link">Role Training</a>
              </li>
              <li class="menu-item" [hidden]="!showBbInvitationsNav">
                <a routerLink="/bb-invite-list" routerLinkActive="active-link" [routerLinkActiveOptions]="{ exact: true }" class="dashboard-link" [class.active-link]="activeLink === 'invitation-management' && !isLlttfInvitationRoute">{{ bbInvitationsNavLabel }}</a>
              </li>
              <li class="menu-item" [hidden]="!showLlttfInvitationsNav">
                <a routerLink="/llttf-invite-list" routerLinkActive="active-link" [routerLinkActiveOptions]="{ exact: true }" class="dashboard-link" [class.active-link]="activeLink === 'invitation-management' && isLlttfInvitationRoute">{{ llttfInvitationsNavLabel }}</a>
              </li>
              <li class="menu-item" [hidden]="!showCourseManagementNav">
                <button
                  mat-button
                  [matMenuTriggerFor]="courseMenu"
                  class="topnav__menu-trigger dashboard-link"
                  [class.active-link]="activeLink === 'course-management'"
                  type="button">
                  <span class="topnav__menu-label">{{ courseManagementNavLabel }}</span>
                  <mat-icon class="topnav__dropdown-icon">expand_more</mat-icon>
                </button>
                <mat-menu #courseMenu="matMenu" class="topnav__flyout-menu">
                  <button mat-menu-item routerLink="/tags-list" [hidden]="!accessControl.tags">Tags</button>
                  <button mat-menu-item routerLink="/material-list" [hidden]="!accessControl.materials">Materials</button>
                  <button mat-menu-item routerLink="/course-list" [hidden]="!accessControl.courses">{{ isLlttfContext ? 'Sessions' : 'Courses' }}</button>
                  <button mat-menu-item routerLink="/bulk-import" [hidden]="!accessControl.canBulkImport">Bulk Import</button>
                </mat-menu>
              </li>
              <li class="menu-item" [hidden]="!showOrgManagementNav">
                <a routerLink="/org-list" [class.active-link]="activeLink === 'org-management'" routerLinkActive="active-link" [routerLinkActiveOptions]="{ exact: true }" class="dashboard-link">Organization</a>
              </li>
              <li class="menu-item" [hidden]="!showReportingNav">
                <button
                  mat-button
                  [matMenuTriggerFor]="reportMenu"
                  class="topnav__menu-trigger dashboard-link"
                  [class.active-link]="activeLink === 'reporting'"
                  type="button">
                  <span class="topnav__menu-label">Reports</span>
                  <mat-icon class="topnav__dropdown-icon">expand_more</mat-icon>
                </button>
                <mat-menu #reportMenu="matMenu" class="topnav__flyout-menu">
                  <button mat-menu-item routerLink="/reports/participant-extract-report">Participant Extract</button>
                  <button mat-menu-item routerLink="/reports/course-extract-report">Course Extract</button>
                </mat-menu>
              </li>
            </ul>

            @if (isParticipant && !lockNavForOnboarding) {
              <ul class="topnav__menu topnav__menu--desktop menu">
                <li class="menu-item">
                  <a routerLink="/dashboard-participant" [class.active-link]="activeLink === 'participant-dashboard'" routerLinkActive="active-link" [routerLinkActiveOptions]="{ exact: true }" class="dashboard-link">{{ dashboardLabel }}</a>
                </li>
                <li class="menu-item">
                  <a routerLink="/participants/courses" [class.active-link]="activeLink === 'participant-course'" routerLinkActive="active-link" [routerLinkActiveOptions]="{ exact: true }" class="dashboard-link">{{ courseMenuName }}</a>
                </li>
              </ul>
            }
          </nav>

          <div class="topnav__actions">
            @if (showProgramToggle) {
              <mat-form-field
                appearance="outline"
                class="topnav__program-select"
                subscriptSizing="dynamic">
                <mat-label>Program</mat-label>
                <mat-select
                  [ngModel]="adminProgramMode"
                  (ngModelChange)="onProgramModeChange($event)"
                  [attr.aria-label]="'Switch program'">
                  <mat-option value="bb">BounceBack</mat-option>
                  <mat-option value="llttf">Living Life to the Full</mat-option>
                </mat-select>
              </mat-form-field>
            }

            @if (isParticipant && !lockNavForOnboarding) {
              <div
                class="topnav__language-toggle"
                role="group"
                [attr.aria-label]="currentLanguage">
                @for (lang of applicationLanguages; track lang) {
                  <button
                    type="button"
                    class="topnav__language-btn"
                    [class.topnav__language-btn--active]="isActiveLanguage(lang.id)"
                    [attr.aria-pressed]="isActiveLanguage(lang.id)"
                    [attr.aria-label]="lang.description"
                    (click)="setLanguage(lang.id)">
                    {{ getLanguageButtonLabel(lang) }}
                  </button>
                }
              </div>
            }

            <div class="user-profile">
              <div class="details">
                <div class="name">
                  <button
                    mat-button
                    [matMenuTriggerFor]="Usermenu"
                    class="nav-link topnav__profile-btn"
                    [attr.aria-label]="username ? 'User menu for ' + username : 'User menu'">
                    <span class="topnav__profile-inner">
                      <span class="topnav__avatar">
                        <mat-icon>person</mat-icon>
                      </span>
                      <span class="profile-name">{{ username }}</span>
                      <fa-icon [icon]="faChevronDown" class="topnav__chevron"></fa-icon>
                    </span>
                  </button>

                  <mat-menu #Usermenu="matMenu" class="dashboard-menu topnav__menu-panel">
                    <button mat-menu-item (click)="changePassword()" [hidden]="!profileVisible || lockNavForOnboarding">
                      <mat-icon>person</mat-icon>
                      <span>{{ profileLabel }}</span>
                    </button>
                    <button mat-menu-item (click)="navigate('/my-training')" [hidden]="!showMyTrainingNav">
                      <mat-icon>school</mat-icon>
                      <span>My Training</span>
                    </button>
                    <button mat-menu-item (click)="navigate('/email-queue')" [hidden]="!accessControl.emailQueue || lockNavForOnboarding">
                      <mat-icon>mail</mat-icon>
                      <span>Email Queue</span>
                    </button>
                    <button mat-menu-item [hidden]="!accessControl.isParticipantBBCoached || lockNavForOnboarding" (click)="setParticipantLastActiveRole(BBCoachedParticipantRole)">
                      <mat-icon>support_agent</mat-icon>
                      <span>{{ bbCoachedProgramLabel }}</span>
                    </button>
                    <button mat-menu-item [hidden]="!accessControl.isParticipantBBSelfGuided || lockNavForOnboarding" (click)="setParticipantLastActiveRole(BBSelfGuidedParticipantRole)">
                      <mat-icon>menu_book</mat-icon>
                      <span>{{ bbSelfGuidedProgramLabel }}</span>
                    </button>
                    <button mat-menu-item [hidden]="!accessControl.isParticipantLLTTFCoached || lockNavForOnboarding" (click)="setParticipantLastActiveRole(LLTTFCoachedParticipantRole)">
                      <mat-icon>school</mat-icon>
                      <span>Living Life to the Full</span>
                    </button>
                    <mat-divider></mat-divider>
                    <button mat-menu-item (click)="logout()" class="topnav__logout-item">
                      <mat-icon>logout</mat-icon>
                      <span>{{ logoutLabel }}</span>
                    </button>
                  </mat-menu>
                </div>
              </div>
            </div>

            <a class="menu-toggle topnav__hamburger" (click)="toggleMenu()" aria-label="Open menu" [attr.aria-expanded]="mobileMenuOpen" [hidden]="lockNavForOnboarding && !showRoleTrainingNav">
              <img src="/assets/hamburger-black.svg" alt="" class="hamburger-icon" />
            </a>
          </div>
        </div>
      </mat-toolbar>
    </div>
  </div>

  <div
    class="topnav__mobile-drawer"
    [class.topnav__mobile-drawer--open]="mobileMenuOpen"
    [attr.aria-hidden]="!mobileMenuOpen">
    <button
      type="button"
      class="topnav__mobile-backdrop"
      (click)="closeMenu()"
      aria-label="Close menu"
    tabindex="-1"></button>

    <aside class="topnav__mobile-panel" role="dialog" aria-modal="true" aria-label="Navigation menu">
      <div class="topnav__mobile-panel-head">
        <span class="topnav__mobile-panel-title">Menu</span>
        <button type="button" class="topnav__mobile-close" (click)="closeMenu()" aria-label="Close menu">
          <img src="/assets/cross.svg" alt="" class="hamburger-icon" />
        </button>
      </div>

      <nav class="topnav__mobile-nav" aria-label="Mobile navigation">
        <ul class="topnav__mobile-menu" *ngIf="!isParticipant">
          <li class="topnav__mobile-item" [hidden]="lockNavForOnboarding">
            <a [routerLink]="homeDashboardPath" routerLinkActive="active-link" [routerLinkActiveOptions]="{ exact: true }" class="dashboard-link" (click)="closeMenu()">Dashboard</a>
          </li>
          <li class="topnav__mobile-item" [hidden]="!accessControl.userManagement || lockNavForOnboarding">
            <a routerLink="/user-list" [class.active-link]="activeLink === 'user-management'" routerLinkActive="active-link" [routerLinkActiveOptions]="{ exact: true }" class="dashboard-link" (click)="closeMenu()">Users</a>
          </li>
          <li class="topnav__mobile-item" [hidden]="!showRoleTrainingNav">
            <a routerLink="/role-training-list" [class.active-link]="activeLink === 'role-training'" routerLinkActive="active-link" [routerLinkActiveOptions]="{ exact: true }" class="dashboard-link" (click)="closeMenu()">Role Training</a>
          </li>
          @if (showProgramToggle) {
            <li class="topnav__mobile-item topnav__mobile-item--group">
              <span class="topnav__mobile-group-label">Program</span>
              <ul class="topnav__mobile-sub">
                <li>
                  <button
                    type="button"
                    class="dashboard-link topnav__mobile-program-btn"
                    [class.active-link]="adminProgramMode === 'bb'"
                    (click)="onProgramModeChange('bb'); closeMenu()">
                    BounceBack
                  </button>
                </li>
                <li>
                  <button
                    type="button"
                    class="dashboard-link topnav__mobile-program-btn"
                    [class.active-link]="adminProgramMode === 'llttf'"
                    (click)="onProgramModeChange('llttf'); closeMenu()">
                    Living Life to the Full
                  </button>
                </li>
              </ul>
            </li>
          }
          <li class="topnav__mobile-item" [hidden]="!showBbInvitationsNav">
            <a routerLink="/bb-invite-list" [class.active-link]="activeLink === 'invitation-management' && !isLlttfInvitationRoute" routerLinkActive="active-link" [routerLinkActiveOptions]="{ exact: true }" class="dashboard-link" (click)="closeMenu()">{{ bbInvitationsNavLabel }}</a>
          </li>
          <li class="topnav__mobile-item" [hidden]="!showLlttfInvitationsNav">
            <a routerLink="/llttf-invite-list" [class.active-link]="activeLink === 'invitation-management' && isLlttfInvitationRoute" routerLinkActive="active-link" [routerLinkActiveOptions]="{ exact: true }" class="dashboard-link" (click)="closeMenu()">{{ llttfInvitationsNavLabel }}</a>
          </li>
          <li class="topnav__mobile-item topnav__mobile-item--group" [hidden]="!showCourseManagementNav">
            <span class="topnav__mobile-group-label" [class.active-link]="activeLink === 'course-management'">{{ courseManagementNavLabel }}</span>
            <ul class="topnav__mobile-sub">
              <li [hidden]="!accessControl.tags">
                <a routerLink="/tags-list" routerLinkActive="active-link" [routerLinkActiveOptions]="{ exact: true }" class="dashboard-link" (click)="closeMenu()">Tags</a>
              </li>
              <li [hidden]="!accessControl.materials">
                <a routerLink="/material-list" routerLinkActive="active-link" [routerLinkActiveOptions]="{ exact: true }" class="dashboard-link" (click)="closeMenu()">Materials</a>
              </li>
              <li [hidden]="!accessControl.courses">
                <a routerLink="/course-list" routerLinkActive="active-link" [routerLinkActiveOptions]="{ exact: true }" class="dashboard-link" (click)="closeMenu()">{{ isLlttfContext ? 'Sessions' : 'Courses' }}</a>
              </li>
              <li [hidden]="!accessControl.canBulkImport">
                <a routerLink="/bulk-import" routerLinkActive="active-link" [routerLinkActiveOptions]="{ exact: true }" class="dashboard-link" (click)="closeMenu()">Bulk Import</a>
              </li>
            </ul>
          </li>
          <li class="topnav__mobile-item" [hidden]="!showOrgManagementNav">
            <a routerLink="/org-list" [class.active-link]="activeLink === 'org-management'" routerLinkActive="active-link" [routerLinkActiveOptions]="{ exact: true }" class="dashboard-link" (click)="closeMenu()">Organization</a>
          </li>
          <li class="topnav__mobile-item topnav__mobile-item--group" [hidden]="!showReportingNav">
            <span class="topnav__mobile-group-label" [class.active-link]="activeLink === 'reporting'">Reports</span>
            <ul class="topnav__mobile-sub">
              <li>
                <a routerLink="/reports/participant-extract-report" routerLinkActive="active-link" [routerLinkActiveOptions]="{ exact: true }" class="dashboard-link" (click)="closeMenu()">Participant Extract</a>
              </li>
              <li>
                <a routerLink="/reports/course-extract-report" routerLinkActive="active-link" [routerLinkActiveOptions]="{ exact: true }" class="dashboard-link" (click)="closeMenu()">Course Extract</a>
              </li>
            </ul>
          </li>
        </ul>

        @if (isParticipant && !lockNavForOnboarding) {
          <ul class="topnav__mobile-menu">
            <li class="topnav__mobile-item">
              <a routerLink="/dashboard-participant" [class.active-link]="activeLink === 'participant-dashboard'" routerLinkActive="active-link" [routerLinkActiveOptions]="{ exact: true }" class="dashboard-link" (click)="closeMenu()">{{ dashboardLabel }}</a>
            </li>
            <li class="topnav__mobile-item">
              <a routerLink="/participants/courses" [class.active-link]="activeLink === 'participant-course'" routerLinkActive="active-link" [routerLinkActiveOptions]="{ exact: true }" class="dashboard-link" (click)="closeMenu()">{{ courseMenuName }}</a>
            </li>
            <li class="topnav__mobile-item topnav__mobile-item--group">
              <span class="topnav__mobile-group-label">{{ currentLanguage }}</span>
              <div class="topnav__mobile-language" role="group" [attr.aria-label]="currentLanguage">
                @for (lang of applicationLanguages; track lang) {
                  <button
                    type="button"
                    class="topnav__language-btn"
                    [class.topnav__language-btn--active]="isActiveLanguage(lang.id)"
                    [attr.aria-pressed]="isActiveLanguage(lang.id)"
                    (click)="setLanguage(lang.id); closeMenu()">
                    {{ getLanguageButtonLabel(lang) }}
                  </button>
                }
              </div>
            </li>
          </ul>
        }
      </nav>
    </aside>
  </div>
</div>
